@if (certification) {
  <div class="snapshot-card">
    <mat-icon class="snapshot-icon">verified</mat-icon>
    <div class="snapshot-body">
      <div class="snapshot-title">{{ certification.name }}</div>
      @if (certification.number) {
        <div class="snapshot-sub">
          {{ certification.number }}
        </div>
      }
      @if (certification.activeDate || certification.expirationDate) {
        <div class="snapshot-sub">
          @if (certification.activeDate) {
            <span>{{
              certification.activeDate | date: 'MMM d, y' : 'utc'
            }}</span>
          }
          @if (certification.activeDate && certification.expirationDate) {
            <span> - </span>
          }
          @if (certification.expirationDate) {
            <span>{{
              certification.expirationDate | date: 'MMM d, y' : 'utc'
            }}</span>
          }
        </div>
      }
    </div>
    <span class="snapshot-status">
      <svg width="10" height="10" class="snapshot-status-dot">
        <circle
          class="status-dot"
          [ngClass]="isActive ? 'green' : 'gray'"
          cx="5"
          cy="5"
          r="4"
          stroke-width="0"
        />
      </svg>
      {{ isActive ? 'Active' : 'Inactive' }}
    </span>
  </div>
}
